import { Heart, Trophy, Flag, Volume2, VolumeX, ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";

const Stat = ({ icon: Icon, label, value, testId, color }) => (
  <div className="flex items-center gap-2 rounded-2xl border border-white/10 bg-white/5 px-3 py-2 backdrop-blur-xl sm:px-4">
    <Icon className={`h-4 w-4 sm:h-5 sm:w-5 ${color}`} />
    <div className="leading-tight">
      <div className="text-[10px] uppercase tracking-[0.18em] text-white/50">{label}</div>
      <div data-testid={testId} className="font-display text-lg font-black text-white sm:text-2xl">{value}</div>
    </div>
  </div>
);

export const Hud = ({ mode, lives, points, best, round, timerOn, muted, onMute, onExit }) => (
  <header className="flex flex-wrap items-center justify-between gap-3">
    <div className="flex items-center gap-3">
      <button data-testid="exit-game-btn" onClick={onExit} className="grid h-11 w-11 place-items-center rounded-2xl border border-white/10 bg-white/5 text-white/80 transition-colors hover:bg-white/15" aria-label="Back to modes">
        <ArrowLeft className="h-5 w-5" />
      </button>
      <div data-testid="lives-display" className="flex items-center gap-1 rounded-2xl border border-white/10 bg-white/5 px-3 py-2 backdrop-blur-xl">
        {Array.from({ length: mode.lives }).map((_, i) => (
          <motion.div key={i} animate={i < lives ? { scale: 1, opacity: 1 } : { scale: 0.75, opacity: 0.25 }} transition={{ type: "spring", stiffness: 400, damping: 15 }}>
            <Heart data-testid={`heart-icon-${i}`} data-alive={i < lives ? "true" : "false"} className={`h-6 w-6 sm:h-7 sm:w-7 ${i < lives ? "fill-[#ff2a6d] text-[#ff2a6d] drop-shadow-[0_0_8px_rgba(255,42,109,0.7)]" : "text-white/40"}`} />
          </motion.div>
        ))}
      </div>
    </div>
    <div className="flex items-center gap-2">
      <Stat icon={Flag} label="Round" value={round} testId="current-round" color="text-cyan-300" />
      <Stat icon={Trophy} label={timerOn ? "Points ×2" : "Points"} value={points} testId="current-score" color="text-[#ffb703]" />
      <Stat icon={Trophy} label="Best" value={best} testId="best-score" color="text-fuchsia-300" />
      <button data-testid="mute-toggle-btn" onClick={onMute} className="grid h-11 w-11 place-items-center rounded-2xl border border-white/10 bg-white/5 text-white/80 transition-colors hover:bg-white/15" aria-label="Toggle sound">
        {muted ? <VolumeX className="h-5 w-5" /> : <Volume2 className="h-5 w-5" />}
      </button>
    </div>
  </header>
);
